import { PatientDemographics } from "@accurx/native";
import {
    PatientHeader,
    calculateAge,
    formatPatientName,
    mapPatientsNames,
} from "@accurx/patient";

import { Inner, StyledWrapper } from "./PatientHeader.styles";

type AddNotePatientHeaderProps = {
    patient: PatientDemographics;
};

export const AddNotePatientHeader = ({
    patient,
}: AddNotePatientHeaderProps) => {
    const { patientName, patientExternalIdentityDto, dateOfBirth } = patient;
    const { patientExternalIds: externalIds } = patientExternalIdentityDto;
    const nameComponents = mapPatientsNames(patientName.usual);

    const name = formatPatientName(nameComponents);
    const ageYear = dateOfBirth ? calculateAge(dateOfBirth) : undefined;
    const nhsNumber = externalIds.find((id) => id.type === "NhsNumber")?.value;

    return (
        <StyledWrapper>
            <Inner>
                <PatientHeader>
                    <PatientHeader.Details>
                        <PatientHeader.Details.Name
                            name={name}
                            ageYear={ageYear}
                            gender={patient.gender}
                        />
                        <PatientHeader.Details.Additional
                            nhsNumber={nhsNumber}
                            dateOfBirth={dateOfBirth || ""}
                        />
                    </PatientHeader.Details>
                </PatientHeader>
            </Inner>
        </StyledWrapper>
    );
};
